import {
    Component,
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    NgZone,
    OnInit,
    OnDestroy,
} from '@angular/core';

import {AuthService} from '../auth/guard.service';
import { Subscription } from 'rxjs/Subscription';
import * as firebase from 'firebase';

@Component({
    templateUrl: './account.component.html',
    styleUrls: ['./account.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccountComponent implements OnInit, OnDestroy {

    public user : firebase.User;
    public providers : {[providerId : string] : firebase.UserInfo};

    private userSubs : Subscription;

    constructor(private auth : AuthService, private ref : ChangeDetectorRef) { }

    str(obj : any) {
        return JSON.stringify(obj, undefined, 4);
    }

    ngOnInit() {
        this.userSubs = this.auth.user.subscribe(user => {
            this.user = user;
            this.providers = {};

            if (this.user) {
                this.user.providerData.forEach(provider => {
                    this.providers[provider.providerId] = provider;
                });
            }

            this.ref.markForCheck();
        });
    }

    logout() {
        this.auth.logout();
    }

    ngOnDestroy() {
        if (this.userSubs) {
            this.userSubs.unsubscribe();
        }
    }

}



// WEBPACK FOOTER //
// /Users/vlad/Projects/done/web/src/app/account/account.component.ts